import styled from 'styled-components';
import { lighten } from 'polished';

export const Container = styled.div`
  a {
    &.dropdown-item {
      p {
        white-space: pre-line;
      }
    }
    &.notification-bell {
      color: ${(props) => props.theme.$dark};
    }
  }

  .notification-dropdown {
    @media screen and (min-width: 980px) {
      width: 400px;
    }
  }

  .notification-pull-right {
    @media screen and (min-width: 980px) {
      line-height: 40px;
      float: right;
      margin-right: 0;
      right: 0;
      left: auto;
    }
  }

  .notification-badge {
    position: relative;
  }

  .notification-badge[data-notification-badge]:after {
    content: attr(data-notification-badge);
    position: absolute;
    right: -3px;
    top: -4px;
    background: ${(props) => props.theme.$danger};
    line-height: 9px;
    border-radius: 50%;
    font-family: sans-serif;
    padding: 2px 4px;
    font-size: 11px !important;
    color: ${(props) => props.theme.$white};
    border: 2px solid ${(props) => props.theme.$white};
    white-space: nowrap;
    font-weight: bold;
  }

  .dropdown-menu {
    width: 350px;
    max-height: 300px;
    font-size: 0.935em;
    overflow: auto;
    color: ${lighten(0.55, '#000')};

    @media only screen and (max-width: 768px) {
      width: 270px;
    }

    a:hover {
      text-decoration: none;
    }

    li {
      cursor: pointer;
    }

    .dropdown-divider {
      margin: 0;
    }

    .new-notification {
      color: ${lighten(0.4, '#000')};
      background-color: ${lighten(0.95, '#000')};
    }

    .all-notifications {
      margin-top: 0.3em;
      a {
        color: $primary;
      }
    }
  }
`;
